import DeleteIcon from '@mui/icons-material/Delete'
import { Button } from '@mui/material'
import DropDownOA from '../common/dropDownOA'
import { useState } from 'react'
import { useEffect } from 'react'
import { STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../common/jotaiState/commonStateAtoms'
export const LrTrackCard = (props) => {
  const { data, lastStatus, isEditable, loginData, vehicleList, cityList, branchList, visibilityFlag } = props
  const [isEdit, setIsEdit] = useState(false)
  const [resetFlag, setResetFlage] = useState(false)
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID} = companySettings || {}
  const [dispatchDetail, setDispatchDetail] = useState({
    intToCityID: data.DispatchedToCityID,
    intToBranchID: data.DispatchedToBranchID,
    strVehicleNo: data.VehicleNo,
    intVehicleID: data.VehicleID,
  })
  const [bookingDetail, setBookingDetail] = useState({
    DestinationCityID: data.DestinationCityID,
    DestinationBranchID: data.DestinationBranchId,
  })
  const [branchTransferDetails, setBranchTransferDetails] = useState({
    intToCityID: data.DispatchedToCityID,
    intToBranchID: data.DispatchedToBranchID,
    strVehicleNo: data.VehicleNo,
    intVehicleID: data.VehicleID,
  })
  useEffect(() => {
    let cityId = 0
    if (props?.lastStatus?.TYPE === 'B') {
      cityId = props?.lastStatus?.DestinationCityID
    } else if (props?.lastStatus?.TYPE === 'T') {
      cityId = props?.lastStatus?.DispatchedToCityID
    } else if (props?.lastStatus?.TYPE === 'D') {
      cityId = props?.lastStatus?.DispatchedToCityID
    } else if (props?.lastStatus?.TYPE === 'L') {
      cityId = props?.lastStatus?.DispatchedToCityID
    }
    props.handleBranch && props.handleBranch(cityId)
  }, [props?.lastStatus])

  const isAPP = data.TypeDet.endsWith('-App') ? 'App' : ''
  // const status = data.TypeDet.endsWith('-App') ? data.TypeDet.slice(0, data.TypeDet.length - 4) : data.TypeDet
  // console.log(status, 'status')
  let status = data.TypeDet.endsWith('-App') ? data.TypeDet.slice(0, -4) : data.TypeDet;
  if (DefaultCurrencyID === 2) {
    if (status === 'Transfered') {
      status = 'Branch Transfer';
    } else if (status === 'Br. Tr. Received') {
      status = 'Sc. Tr. Receive';
    } else if (status === 'Out for Delivery') {
      status = 'Assign Delivery';
    } else if (status === 'Out-Delivered') {
      status = 'Pending Out Delivery';
    }
  }
  const IsShortReceived = data.TYPE === 'D' && data.IsShortReceived === 1
  switch (data.TYPE) {
    case 'B':
      return (
        <>
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Date and Time</div>
                <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading bkg-status red">{status}</div>
                <div className="lrt-details">{isAPP}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Source</div>
                <div className="lrt-details">{data.FromCity || data.SourceCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Destination City</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    defaultvalue={data.DestinationCity || ''}
                    // value={data.DispatchedToCity}
                    data={cityList.filter((val) => val.CityID !== data.SourceCityID) || []}
                    width="100%"
                    searchPlaceholder={'Search By City'}
                    tabIndex="2"
                    typeOf={1}
                    isObjArr={true}
                    dataKey={`CityName`}
                    idKey={`CityID`}
                    onSelect={(e) => {
                      setResetFlage(true)
                      props.handleBranch(e.CityID)
                      // dispatchDetail
                      setBookingDetail({ ...bookingDetail, DestinationCityID: e.CityID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToCity || data.DestinationCity}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Source Branch</div>
                <div className="lrt-details">{data.BranchName || data.SourceBranch}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Destination Branch</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={branchList || []}
                    defaultvalue={data.DestinationBranch || ''}
                    width="100%"
                    searchPlaceholder={'Search By Branch'}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="5"
                    resetFlag={resetFlag}
                    onSelect={(e) => {
                      setResetFlage(false)
                      setBookingDetail({ ...bookingDetail, DestinationBranchID: e.BranchID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToBranchName || data.DestinationBranch}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Booked By User</div>
                <div className="lrt-details">{data.TransactionByUser || data.BookedByUser}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading"></div>
                <div className="lrt-details"></div>
              </div>
            </div>

            <div
              className="lrt-card-row"
              style={{
                textAlign: 'center',
                display:
                  lastStatus?.TYPE === data.TYPE &&
                  visibilityFlag?.AllowAdminSendAndRecChange === 1 &&
                  visibilityFlag?.AllowAdminDestinationChange === 1 &&
                  loginData.intCompanyID !== STA_COMPANY_ID
                    ? ''
                    : 'none',
              }}
            >
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                  //  onKeyDown={(e) => {}}
                  disabled={isEdit}
                >
                  Edit
                </Button>
              </div>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(false)
                    props.handleBookingUpdate(data, bookingDetail)
                    //props.
                  }}
                  disabled={!isEdit}
                //  onKeyDown={(e) => {}}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </>
      )
    case 'D':
      return (
        <>
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Date and Time</div>
                <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                {isEditable === 'update' && visibilityFlag?.AllowAdminCancelDispatch === 1 ? (
                  <span
                    onClick={(e) => {
                      props.handleCancelDispatch(data)
                    }}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span>
                ) : (
                  ''
                )}
                <div className="lrt-heading bkg-status blue">{status}</div>
                <div className="lrt-details">{isAPP}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Dispatched From</div>
                <div className="lrt-details">{data.FromCity || data.DispatchedFromCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Dispatched To</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    defaultvalue={data.DispatchedToCity || ''}
                    // value={data.DispatchedToCity}
                    data={cityList.filter((val) => val.CityID !== data.DispatchedFromCityID) || []}
                    width="100%"
                    searchPlaceholder={'Search By City'}
                    tabIndex="2"
                    typeOf={1}
                    isObjArr={true}
                    dataKey={`CityName`}
                    idKey={`CityID`}
                    onSelect={(e) => {
                      setResetFlage(true)
                      props.handleBranch(e.CityID)
                      // dispatchDetail
                      setDispatchDetail({ ...dispatchDetail, intToCityID: e.CityID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToCity || data.DispatchedToCity}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Dispatched From Branch</div>
                <div className="lrt-details">{data.DispatchedFromBranch}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Dispatched To Branch</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={branchList || []}
                    defaultvalue={data.DispatchedToBranch || ''}
                    width="100%"
                    searchPlaceholder={'Search By Branch'}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="5"
                    resetFlag={resetFlag}
                    onSelect={(e) => {
                      setResetFlage(false)
                      setDispatchDetail({ ...dispatchDetail, intToBranchID: e.BranchID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.BranchName || data.DispatchedToBranch}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading"> Dispatched By User</div>
                <div className="lrt-details">{data.TransactionByUser || data.DispatchedByUser}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Dispatched in Vehicle</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={vehicleList || []}
                    defaultvalue={data.VehicleNo}
                    width="100%"
                    searchPlaceholder={'Search By'}
                    isObjArr={true}
                    dataKey={`VehicleNo`}
                    idKey={`VehicleNo`}
                    tabIndex="5"
                    onSelect={(e) => {
                      setDispatchDetail({ ...dispatchDetail, strVehicleNo: e.VehicleNo })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.VehicleNo}</div>
                )}
              </div>
            </div>
            <div
              className="lrt-card-row"
              style={{
                textAlign: 'center',
                display: lastStatus?.TYPE === data.TYPE && visibilityFlag?.AllowAdminDispatchChange === 1 ? '' : 'none',
              }}
            >
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                  //  onKeyDown={(e) => {}}
                  disabled={isEdit}
                >
                  Edit
                </Button>
              </div>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(false)
                    props.handleDispatchUpdate(data, dispatchDetail)
                  }}
                  disabled={!isEdit}
                //  onKeyDown={(e) => {}}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
          {IsShortReceived && (
            <>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Date and Time</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">Short Received</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading"> By User</div>
                    <div className="lrt-details">{ data.ShortReceivedByUserName}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading"></div>
                    <div className="lrt-details"></div>
                  </div>
                </div>
              </div>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Date and Time</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">Back</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Back To City</div>
                    <div className="lrt-details">{data.FromCity}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">Back from City</div>
                    <div className="lrt-details">{data.ToCity}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Back To Branch</div>
                    <div className="lrt-details">{data.DispatchedFromBranch}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">Back from Branch</div>
                    <div className="lrt-details">{data.BranchName}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">By User</div>
                    <div className="lrt-details">{data.TransactionByUser}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">Dispatched in Vehicle</div>
                    <div className="lrt-details">{data.VehicleNo}</div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )
    case 'T':
      return (
        <>
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Date and Time</div>
                <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                {/* {isEditable === 'update' && visibilityFlag?.AllowAdminCancelBranchTransReceive === 1 ? ( */}
                {isEditable === 'update' && visibilityFlag?.AllowAdminCancelDispatch === 1 ? (
                  <span
                    onClick={(e) => {
                      props.handleCancelBranchTransfer(data)
                    }}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span>
                ) : (
                  ''
                )}
                <div className="lrt-heading bkg-status blue">{status}</div>
                <div className="lrt-details">{isAPP}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Transfer From</div>
                <div className="lrt-details">{data.FromCity || data.DispatchedFromCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Transferred To</div>
                <div className="lrt-details">{data.ToCity || data.DispatchedToCity}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Transfer From Branch</div>
                <div className="lrt-details">{data.BranchName}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Transferred To Branch</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={branchList.filter((val) => val.BranchID !== data.DispatchedFromBranchID) || []}
                    defaultvalue={data.DispatchedToBranch || ''}
                    width="100%"
                    searchPlaceholder={'Search By Branch'}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="5"
                    resetFlag={resetFlag}
                    onSelect={(e) => {
                      setResetFlage(false)
                      setBranchTransferDetails({ ...branchTransferDetails, intToBranchID: e.BranchID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToBranchName || data.DispatchedToBranch}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading"> Transferred By User</div>
                <div className="lrt-details">{data.TransactionByUser || data.DispatchedByUser}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Transferred By Vehicle</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={vehicleList || []}
                    defaultvalue={data.VehicleNo}
                    width="100%"
                    searchPlaceholder={'Search By'}
                    isObjArr={true}
                    dataKey={`VehicleNo`}
                    idKey={`VehicleNo`}
                    tabIndex="5"
                    onSelect={(e) => {
                      setBranchTransferDetails({ ...branchTransferDetails, strVehicleNo: e.VehicleNo })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.VehicleNo}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row" style={{ textAlign: 'center', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                  //  onKeyDown={(e) => {}}
                  disabled={isEdit}
                >
                  Edit
                </Button>
              </div>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(false)
                    props.handleBranchTransferUpdate(data, branchTransferDetails)
                  }}
                  disabled={!isEdit}
                //  onKeyDown={(e) => {}}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
          {IsShortReceived && (
            <>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Date and Time</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">Short Received</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading"> By User</div>
                    <div className="lrt-details">{data.TransactionByUser || data.DispatchedByUser}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading"></div>
                    <div className="lrt-details"></div>
                  </div>
                </div>
              </div>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Date and Time</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">Back</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Back To City</div>
                    <div className="lrt-details">{data.FromCity}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">Back from City</div>
                    <div className="lrt-details">{data.ToCity}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">Back To Branch</div>
                    <div className="lrt-details"></div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">Back from Branch</div>
                    <div className="lrt-details">{data.BranchName}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">By User</div>
                    <div className="lrt-details">{data.TransactionByUser}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">Dispatched in Vehicle</div>
                    <div className="lrt-details">{data.VehicleNo}</div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )
    case 'R':
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Date and Time</div>
              <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {isEditable === 'update' && visibilityFlag?.AllowAdminCancelReceive === 1 ? (
                <span
                  onClick={(e) => {
                    props.handleCancelReceive(data)
                  }}
                  style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                >
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status blue">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Dispatched By</div>
              <div className="lrt-details">{data.FromCity || data.DispatchedBy}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Recived By</div>
              <div className="lrt-details">{data.ToCity || data.ReceivedBy}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Dispatched By Branch</div>
              <div className="lrt-details">{data.DispatchedFromBranch}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Received By Branch</div>
              <div className="lrt-details">{data.BranchName || data.ReceivedByBranch}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Received By User</div>
              <div className="lrt-details">{data.TransactionByUser || data.ReceivedByUser}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading"></div>
              <div className="lrt-details"></div>
            </div>
          </div>
        </div>
      )
    case 'G':
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Date and Time</div>
              <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {isEditable === 'update' && visibilityFlag?.AllowAdminCancelReceive === 1 ? (
                <span
                  onClick={(e) => {
                    props.handleCancelBranchTransferReceive(data)
                  }}
                  style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                >
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status blue">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Transfer From</div>
              <div className="lrt-details">{data.FromCity || data.DispatchedBy}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Transferred At</div>
              <div className="lrt-details">{data.ToCity || data.ReceivedBy}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Transfer From Branch</div>
              <div className="lrt-details">{data.BranchName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Transfer Received At Branch</div>
              <div className="lrt-details">{data.ToBranchName || data.ReceivedByBranch}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading"> Transfer Received By Vehicle</div>
              <div className="lrt-details">{data.VehicleNo}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Transfer Received By User</div>
              <div className="lrt-details">{data.TransactionByUser || data.ReceivedByUser}</div>
            </div>
          </div>
        </div>
      )
    case 'F':
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Date and Time</div>
              <div className="lrt-details">{data.DTTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading bkg-status blue"></div>
              {isEditable === 'update' ? (
                <span style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status green-text">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Delivered at</div>
              <div className="lrt-details">{data.ToCity}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Recepient Name</div>
              <div className="lrt-details">{data.ReceivedBy}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Delivered by Branch</div>
              <div className="lrt-details">{data.BranchName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Recepient Number</div>
              <div className="lrt-details">{data.ReceiverMobileNo}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Delivered By</div>
              <div className="lrt-details">{data.TransactionByUser}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Delivery Vehicle</div>
              <div className="lrt-details">{data.VehicleNo}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Remark</div>
              <div className="lrt-details">{data.Remarks}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading"></div>
              <div className="lrt-details"></div>
            </div>
          </div>
          <div className="lrt-card-row" style={{ textAlign: 'center', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(true)
                }}
                //  onKeyDown={(e) => {}}
                disabled={isEdit}
              >
                Edit
              </Button>
            </div>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(false)
                }}
                disabled={!isEdit}
              //  onKeyDown={(e) => {}}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )
      case 'L':
        return (
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Date and Time</div>
                <div className="lrt-details">{data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding" style={{display:'flex',padding:'0px',alignItems:'center',justifyContent:'space-between',paddingLeft:'10px'}}>
                <div className="lrt-heading bkg-status red">Lost</div>
                <div className="lrt-card-row-right box-padding" style={{cursor:'pointer'}}>
                  <span onClick={(e) => {props.handleMarkedAsLost(data)}}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span>
                  {/* <span onClick={(e) => {props.handleCancelDispatch(data)}}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span> */}
                </div>
                <div className="lrt-details">{isAPP}</div>
              </div>
  
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Source</div>
                <div className="lrt-details">{data.FromCity || data.SourceCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Destination City</div>
                <div className="lrt-details">{data.DestinationCity}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Source Branch</div>
                <div className="lrt-details">{data.SourceBranch}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">Destination Branch</div>
                <div className="lrt-details">{data.DestinationBranch}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">Marked as Lost By User</div>
                <div className="lrt-details">{data.MarkAsLostByUser}</div>
              </div>
            </div>
          </div>
        )
    default:
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Date and Time</div>
              <div className="lrt-details">{data.DTTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {isEditable === 'update' ? (
                <span style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status blue ">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Source</div>
              <div className="lrt-details">{data.FromCity}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Destination</div>
              <div className="lrt-details">{data.ToCity}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Source Branch</div>
              <div className="lrt-details">{data.BranchName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">Destination Branch</div>
              <div className="lrt-details">{data.ToBranchName}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">Transaction By User</div>
              <div className="lrt-details">{data.TransactionByUser}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading"></div>
              <div className="lrt-details"></div>
            </div>
          </div>
          <div className="lrt-card-row" style={{ textAlign: 'center', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(true)
                }}
                //  onKeyDown={(e) => {}}
                disabled={isEdit}
              >
                Edit
              </Button>
            </div>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(false)
                }}
                disabled={!isEdit}
              //  onKeyDown={(e) => {}}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )
  }
}
